import styled from 'styled-components';

export const MobileBottomBarContainer = styled.div`
    position: sticky;
    width: 100%;
    height: 60px;
    bottom: 0;
    -webkit-box-shadow: 0px -4px 3px rgba(0, 0, 0, 0.2);
    -moz-box-shadow: 0px -4px 3px rgba(0, 0, 0, 0.2);
    box-shadow: 0px -4px 3px rgba(0, 0, 0, 0.2);
`;
